<template>
  <td>{{ model[firstAttribute] }} / {{ model[secondAttribute] }}</td>
</template>

<script>
export default {
  props: ["model", "attribute"],
  computed: {
    firstAttribute() {
      return this.attribute.firstAttribute;
    },
    secondAttribute() {
      return this.attribute.secondAttribute;
    }
  }
};
</script>
